class Product {
  constructor(currentConfiguration, base, wingLeft, wingMiddle, wingRight, handle) {
    this.currentConfiguration = currentConfiguration;
    this.base = base;
    this.wingLeft = wingLeft ?? { top: null, middle: null, bottom: null };
    this.wingMiddle = wingMiddle ?? { top: null, middle: null, bottom: null };
    this.wingRight = wingRight ?? { top: null, middle: null, bottom: null };
    this.handle = handle;
  }

  setCustom(op) {
    this.currentConfiguration = op;

    this.wingLeft.top.visible = op === "1700a";
    this.wingRight.top.visible = op === "1700a";

    this.wingLeft.bottom.visible = op === "1700a";
    this.wingRight.bottom.visible = op === "1700a";

    this.wingLeft.left.visible = op === "1700a";
    this.wingRight.left.visible = op === "1700a";

    this.wingLeft.right.visible = op === "1700a";
    this.wingRight.right.visible = op === "1700a";
  }

  setColor(color) {
    const frame = this.base.children[0].children[0];
    frame.material.color.setHex(color);
    Object.values(this.wingLeft).forEach(item => {
      if (item && item.children)
        item.children[0].material.color.setHex(color);
    });
    Object.values(this.wingRight).forEach(item => {
      if (item && item.children)
        item.children[0].material.color.setHex(color);
    });

  }
}

export default Product;